const webApps = [
  {
    id: 32,
    title: 'React Weather App',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_40/v1621906984/weatherApp_z5rs3b.png',
    description: 'This is a web app which provide the current weather situation of a selected city',
    liveDemo: 'https://weatheroutlook.netlify.app/',
    github: 'https://github.com/Mar-Issah/REACT-WEATHER-APP.git',
    tags: ['VSC', 'Git', 'HTML5', 'CSS3', 'ES6', 'React.js ', ' Bootstrap', 'Weather API'],
  },
  {
    id: 31,
    title: 'PERN Todo-List',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1640111319/My%20Website%20Projects/pern_todlist_oiknvt.png',
    description: 'A web application which allows user to create, edit and delete their todo list',
    liveDemo: 'https://todonote.netlify.app',
    github: 'https://github.com/Mar-Issah/PERN-Todo-List.git',
    tags: [
      'VSC',
      'Git',
      'HTML5',
      'CSS3',
      'JavaScript',
      ' ES6',
      'React.js ',
      'Node.js',
      'Express.js',
      'React Bootstrap',
      'PostgresSQL',
    ],
  },
  {
    id: 2,
    title: 'React Exercise Tracker',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617839139/My%20Website%20Projects/react_extracker_bl5xp8.png',
    description:
      'A web application which allows user to create and store username and exercises (description, duration and date)',
    liveDemo: 'https://exerciselogger.netlify.app/',
    github: 'https://github.com/Mar-Issah/React-Exercise-Tracker',
    tags: [
      'VSC',
      'HTML5',
      'CSS3 ',
      'MongoDb',
      'Node.js',
      'ES6 ',
      'React.js',
      'Express.js ',
      'Git ',
      'JavaScript',
      'Bootstrap',
    ],
  },
  {
    id: 1,
    title: 'Pomodoro Clock',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_25/v1617412489/My%20Website%20Projects/pomodoro_clock_ep2eew.png',
    description:
      'This is a clock that gives you a prescribed interval of 25 minutes of work followed by a 5-minute break',
    liveDemo: 'https://codepen.io/marsiya-issah/full/GRNdrrr',
    github: 'https://github.com/Mar-Issah/Pomodoro-Clock',
    tags: ['VSC', 'Git', 'HTML5', 'CSS3', 'ES6', 'React.js ', 'Node.js', 'JavaScript', ' Material Icons'],
  },
  {
    id: 3,
    title: 'Random Quote Machine',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617297529/My%20Website%20Projects/random_quote_machine_twdozo.png',
    description: 'A web application which displays random quotes made by famous people',
    liveDemo: 'https://codepen.io/marsiya-issah/full/xxRgjZq',
    github: 'https://github.com/Mar-Issah/Random-Quote-Machine',
    tags: ['VSC', 'Git', 'HTML5', 'CSS3', 'SASS', 'JavaScript', 'ES6', 'Node.js', 'React.js', 'Bootstrap'],
  },
  {
    id: 4,
    title: 'Markdown Previewer',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617387767/My%20Website%20Projects/markdown_nkf2lr.png',
    description: 'This is a web application converts and preview markdown text to HTML',
    liveDemo: 'https://codepen.io/marsiya-issah/full/qBqPExB',
    github: 'https://github.com/Mar-Issah/Markdown-Previewer-',
    tags: ['VSC', 'HTML5', 'CSS3', 'Node.js', 'JavaScript ', 'ES6', ' React.js', 'Git', 'Bootstrap'],
  },
  {
    id: 5,
    title: 'The Drum Machine',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617411021/My%20Website%20Projects/drum_machine_kj715r.png',
    description:
      'An electronic musical instrument that creates percussion sounds and drum beats as you press or click on the keys',
    liveDemo: 'https://codepen.io/marsiya-issah/full/vYyewqR',
    github: 'https://github.com/Mar-Issah/Drum-Machine',
    tags: ['VSC', 'HTML5 ', 'CSS3 ', 'JavaScript ', 'ES6', 'Node.js', 'React.js', 'Git', 'Bootstrap', 'Font Awesome'],
  },
  {
    id: 6,
    title: 'My Grocery List',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617543115/My%20Website%20Projects/grocery_list2_sccjhi.png',
    description: 'This app allows you to create and manage grocery/ shopping list on your computer',
    liveDemo: 'https://codepen.io/marsiya-issah/full/ZELyEZb',
    github: 'https://github.com/Mar-Issah/Grocery-List',
    tags: ['VSC', 'HTML5 ', 'CSS3 ', 'JavaScript ', 'ES6', 'JQuery', 'Git', 'Font Awesome'],
  },
  {
    id: 7,
    title: 'Sales Countdown Timer',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617237028/My%20Website%20Projects/sales_countdown_timer_jkgdxj.png',
    description:
      'This displays sales countdown timer in single product page . The clocks run every second until time elapses',
    liveDemo: 'https://codepen.io/mar-issah/full/YzdxGPQ',
    github: 'https://github.com/Mar-Issah/Sales-Countdown-Timer',
    tags: ['VSC', 'HTML5 ', 'CSS3 ', 'JavaScript ', 'ES6', 'Git'],
  },
  {
    id: 8,
    title: 'Lorem Ipsum Text Generator',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617221377/My%20Website%20Projects/lorem_text_gen.3_suhvi4.png',
    description: 'Easily generate Lorem Ipsum placeholder text for your project in any number of paragraphs',
    liveDemo: 'https://codepen.io/marsiya-issah/full/ZEpyPYE',
    github: 'https://github.com/Mar-Issah/Lorem-Ipsum-Text-Generator',
    tags: ['VSC', 'HTML5 ', 'CSS3 ', 'JavaScript ', 'ES6', 'Git'],
  },
  {
    id: 9,
    title: 'Fashion and Clothing Store',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617550765/My%20Website%20Projects/Ecommerce%20-%20simple/ecommerce_dlbve7.png',
    description:
      'This is a simple web application which displays items available in a store from women, men and kids clothes and accessories',
    liveDemo: 'https://codepen.io/marsiya-issah/full/eYgRNMP',
    github: 'https://github.com/Mar-Issah/Fashion-and-Clothing-Store',
    tags: ['VSC', 'HTML5 ', 'CSS3 ', 'JavaScript ', 'ES6', 'Git'],
  },
  {
    id: 21,
    title: 'Travel 2021',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617292175/My%20Website%20Projects/travel_2021_meiwch.png',
    description:
      'This is a slideshow for cycling through list of countries to visit. The surprise me button randomly selects a country',
    liveDemo: 'https://codepen.io/marsiya-issah/full/gOwREXB',
    github: 'https://github.com/Mar-Issah/Travel-2021',
    tags: ['VSC', 'HTML5', 'CSS3 ', 'Git ', 'ES6 ', 'JavaScript'],
  },
  {
    id: 22,
    title: 'Personal Portfolio Webpage',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_30/v1617298125/My%20Website%20Projects/personal_port_wlenpr.png',
    description: 'A Personal Portfolio Webpage built with pure HTML5 and CSS3',
    liveDemo: 'https://codepen.io/marsiya-issah/full/JjROdPB',
    github: 'https://github.com/Mar-Issah/Personal-Portfolio-Webpage',
    tags: ['VSC', 'HTML5', 'CSS3 ', 'Git'],
  },
  {
    id: 24,
    title: 'React Calculator',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617482527/My%20Website%20Projects/React_Calculator_jnhdfw.png',
    description: 'A simple react calculator. A replica of ios calcultor User Interface',
    liveDemo: 'https://codepen.io/marsiya-issah/full/MWbVENq',
    github: 'https://github.com/Mar-Issah/React-Calculator',
    tags: ['VSC', 'HTML5', 'CSS3', 'JavaScript', 'React.js', 'Bootstrap', 'Git'],
  },
  {
    id: 25,
    title: 'JavaScript Calculator',
    url: 'https://res.cloudinary.com/dytnpjxrd/image/upload/b_rgb:000000,o_20/v1617240680/My%20Website%20Projects/js_calculator_rb1uvj.png',
    description: 'A calculator built with JavaScript',
    liveDemo: 'https://codepen.io/marsiya-issah/full/PoGKWpB',
    github: 'https://github.com/Mar-Issah/JavaScript-Calculator',
    tags: ['VSC', 'HTML5', 'CSS3', 'JavaScript', 'Git'],
  },
  {
    id: 30,
    title: '',
    url: 'https://',
    description: 'more awesome app coming soon...',
    liveDemo: 'https://',
    github: 'https://',
    tags: [],
  },
];

export default webApps;
